import React, { useState, useEffect, useCallback, useRef } from "react";
import { NavLink, Outlet, useLocation, useMatch } from "react-router-dom";
import {
  getFirestore,
  collection,
  doc,
  getDoc,
  getDocs,
  deleteDoc,
} from "firebase/firestore";
import ArrowRightIcon from "@untitled-ui/icons-react/build/esm/ArrowRight";
import Edit02Icon from "@untitled-ui/icons-react/build/esm/Edit02";
import DeleteIcon from "@untitled-ui/icons-react/build/esm/XSquare";
import {
  Box,
  Button,
  Tabs,
  Container,
  Stack,
  SvgIcon,
  Typography,
  Chip,
  Link,
  Tab,
  Divider,
  Grid,
  Card,
  CardHeader,
  useMediaQuery,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  DialogContent,
  Alert,
  Dialog,
} from "@mui/material";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { format } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import { Scrollbar } from "../../components/scrollbar";
import { useAuth } from "../../hooks/useAuth";
import { useParams, useNavigate } from "react-router-dom";
import { AccountTeamSettings } from "../../sections/dashboard/account/account-team-settings";
import { PropertyList } from "../../components/property-list";
import { PropertyListItem } from "../../components/property-list-item";
import { MoreMenu } from "../../components/more-menu";

import ArrowLeftIcon from "@untitled-ui/icons-react/build/esm/ArrowLeft";
import ChevronDownIcon from "@untitled-ui/icons-react/build/esm/ChevronDown";
import { GrandeExpediente } from "../../sections/dashboard/account/grande-expediente";

type RoomParams = {
  id: string;
};

//@ts-ignore
export function EntidadesInfo() {
  const params = useParams<RoomParams>();
  const roomId = params.id;
  const navigate = useNavigate();

  const auth = getAuth();

  const [currentTab, setCurrentTab] = useState("details");
  const [filters, setFilters] = useState({});
  const [entidades, setEntidades] = useState({});

  const [atas, setAtas] = useState([]);

  const [open, setOnOpen] = useState(false);
  const [files, setFiles] = useState([]);

  const [paltasSessao, setPaltasSessao] = useState([]);

  useEffect(() => {
    setFiles([]);
  }, [open]);

  //@ts-ignore
  const handleTabsChange = useCallback((event, value) => {
    setCurrentTab(value);
    setFilters((prevState) => {
      const updatedFilters = {
        ...prevState,
        hasAcceptedMarketing: undefined,
        isProspect: undefined,
        isReturning: undefined,
      };

      if (value !== "all") {
        //@ts-ignore
        updatedFilters[value] = true;
      }

      return updatedFilters;
    });
  }, []);

  const tabs = [
    { label: "Detalhes", value: "details" },
    { label: "Pequeno Expediente", value: "pequeno-expediente" },
    { label: "Grande Expediente", value: "grande-expediente" },
    { label: "Atas do Expediente", value: "atas" },
    { label: "Pautas Legislativas", value: "paltasLegislativas" },
    // { label: 'Votação das Paltas', value: 'votacaoPaltas' },
  ];

  async function BuscaPaltas() {
    const db = getFirestore();
    const consulta1Snapshot = await getDocs(
      collection(db, "users", "belacruz@eleg", "sessoes", `${roomId}`, "paltas")
    );

    //@ts-ignore
    const resultadosAdicionais = [];

    // Realizar consultas adicionais para cada documento retornado pela primeira consulta
    await Promise.all(
      consulta1Snapshot.docs.map(async (docSnapshot) => {
        //@ts-ignore
        const documentoRef = doc(
          db,
          "users",
          "belacruz@eleg",
          "paltas",
          docSnapshot.data().idPalta
        );
        const consultaAdicionalSnapshot = await getDoc(documentoRef);
        resultadosAdicionais.push(consultaAdicionalSnapshot.data());
      })
    );

    //@ts-ignore
    setPaltasSessao(resultadosAdicionais);
  }

  function useMounted() {
    const isMounted = useRef(false);

    useEffect(() => {
      isMounted.current = true;

      return () => {
        const db = getFirestore();

        const ordersRef = doc(
          db,
          "users",
          "belacruz@eleg",
          "sessoes",
          `${roomId}`
        );

        getDoc(ordersRef)
          .then((docSnapshot) => {
            if (docSnapshot.exists()) {
              const data = docSnapshot.data();
              const obj = {
                id: docSnapshot.id,
                sessao: data.sessao,
                legislatura: data.legislatura,
                dataSessao: data.dataSessao,
                dataSessaoVis: format(
                  new Date(data.dataSessao),
                  "d 'de' MMMM 'de' yyyy",
                  { locale: ptBR }
                ),
                tipoSessao: data.tipoSessao,
              };
              setEntidades(obj);
            } else {
              console.log("Documento não encontrado");
            }
          })
          .catch((error) => {
            console.log("Erro ao recuperar dados do documento:", error);
          });

        const ordersRefAtas = collection(
          db,
          "users",
          `belacruz@eleg`,
          "sessoes",
          `${roomId}`,
          "atas"
        );

        getDocs(ordersRefAtas)
          .then((querySnapshot) => {
            const parsedData = querySnapshot.docs.map((doc) => {
              const data = doc.data();
              // Cria um objeto com as propriedades e seus respectivos valores
              const obj = {
                id: doc.id,
                textoAta: data.textoAta,
                tituloAtaExpediente: data.tituloAtaExpediente,
                // Adicione outras propriedades e seus valores aqui, se necessário
              };
              return obj;
            });

            //@ts-ignore
            setAtas(parsedData);
          })
          .catch((error) => {
            console.log("Erro ao recuperar dados da subcoleção:", error);
          });

        BuscaPaltas();

        isMounted.current = false;
      };
    }, []);

    return useCallback(() => isMounted.current, []);
  }

  useMounted();

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 4,
      }}
    >
      <Dialog fullWidth maxWidth="xs" open={open}>
        <DialogContent>
          <Stack
            sx={{
              width: "100%",
            }}
          >
            <Alert severity="warning">
              Não é possível reverter esta ação. Tem certeza?
            </Alert>

            <Stack
              sx={{
                width: "100%",
                alignSelf: "flex-end",
                marginTop: 0,
              }}
              justifyContent="flex-end"
              alignItems="flex-end"
              spacing={2}
              flexDirection="row"
            >
              <Button
                color="error"
                onClick={async () => {
                  const db = getFirestore();
                  await deleteDoc(
                    doc(db, "users", "belacruz@eleg", "sessoes", `${roomId}`)
                  );
                  navigate("/sessoes");
                  setOnOpen(false);
                }}
              >
                Apagar mesmo assim
              </Button>
              <Button
                color="inherit"
                onClick={() => {
                  setOnOpen(false);
                }}
              >
                Cancelar
              </Button>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>

      <Container maxWidth="xl">
        <Stack spacing={4}>
          <Stack spacing={4}>
            <div>
              <NavLink to="/sessoes">
                <Link
                  color="text.primary"
                  sx={{
                    alignItems: "center",
                    display: "inline-flex",
                  }}
                  underline="hover"
                >
                  <SvgIcon sx={{ mr: 1 }}>
                    <ArrowLeftIcon />
                  </SvgIcon>
                  <Typography variant="subtitle2">Voltar</Typography>
                </Link>
              </NavLink>
            </div>

            <Stack
              alignItems="flex-start"
              direction={{
                xs: "column",
                md: "row",
              }}
              justifyContent="space-between"
              spacing={4}
            >
              <Stack alignItems="center" direction="row" spacing={2}>
                <Stack spacing={1}>
                  <Typography variant="h4">
                    {/* @ts-ignore */}
                    Sessão {entidades.sessao}
                  </Typography>
                  <Stack alignItems="center" direction="row" spacing={1}>
                    <Chip
                      //@ts-ignore
                      label={`${
                        //@ts-ignore
                        (entidades.legislatura === "2025-2028" &&
                          "Legislatura (2025) - (2028)") ||
                        //@ts-ignore
                        (entidades.legislatura === "2021-2024" &&
                          "Legislatura (2021) - (2024)") ||
                        //@ts-ignore
                        (entidades.legislatura == "" && "Não informado")
                      }`}
                      size="small"
                    />
                  </Stack>
                </Stack>
              </Stack>
              <Stack alignItems="center" direction="row" spacing={2}>
                <Button
                  color="error"
                  onClick={() => {
                    setOnOpen(true);
                  }}
                  endIcon={
                    <SvgIcon>
                      <DeleteIcon />
                    </SvgIcon>
                  }
                >
                  Apagar
                </Button>
                <Button
                  color="inherit"
                  onClick={() => {
                    //@ts-ignore
                    navigate(`/sessoes/${roomId}/edit`);
                  }}
                  endIcon={
                    <SvgIcon>
                      <Edit02Icon />
                    </SvgIcon>
                  }
                >
                  Editar
                </Button>
              </Stack>
            </Stack>

            <div>
              <Tabs
                indicatorColor="primary"
                onChange={handleTabsChange}
                scrollButtons="auto"
                sx={{ mt: 3 }}
                textColor="primary"
                value={currentTab}
                variant="scrollable"
              >
                {tabs.map((tab) => (
                  <Tab
                    key={tab.value}
                    label={tab.label}
                    value={tab.value}
                    sx={{
                      paddingX: 4.3,
                    }}
                  />
                ))}
              </Tabs>
              <Divider />
            </div>
          </Stack>

          {currentTab === "details" && (
            <div>
              <Grid spacing={4}>
                <Grid xs={12} lg={3.75}>
                  <Card
                    style={{
                      paddingBottom: 10,
                    }}
                  >
                    <CardHeader title="Detalhes básicos" />

                    <PropertyList>
                      <PropertyListItem
                        //@ts-ignore
                        divider
                        label="Legistura"
                        //@ts-ignore
                        value={
                          //@ts-ignore
                          (entidades.legislatura === "2025-2028" &&
                            "Legislatura (2025) - (2028)") ||
                          //@ts-ignore
                          (entidades.legislatura === "2021-2024" &&
                            "Legislatura (2021) - (2024)") ||
                          //@ts-ignore
                          (entidades.legislatura == "" && "Não informado")
                        }
                      />
                      <PropertyListItem
                        //@ts-ignore
                        divider
                        label="Sessão"
                        //@ts-ignore
                        value={entidades.sessao}
                      />
                      <PropertyListItem
                        //@ts-ignore
                        divider
                        label="Tipo Sessão"
                        //@ts-ignore
                        value={
                          //@ts-ignore
                          entidades.tipoSessao === "extraordinaria"
                            ? "Extraordinária"
                            : "Ordinária"
                        }
                      />
                      <PropertyListItem
                        label="Data da Sessão"
                        //@ts-ignore
                        value={entidades.dataSessaoVis}
                      />
                    </PropertyList>
                  </Card>
                </Grid>
              </Grid>
            </div>
          )}
          {currentTab === "pequeno-expediente" && (
            <div>
              <Grid spacing={4}>
                <Grid xs={12} lg={3.75}>
                  <AccountTeamSettings
                    members={[
                      {
                        avatar: "/assets/avatars/avatar-anika-visser.png",
                        email: `${auth.currentUser?.email}`,
                        name: `${auth.currentUser?.displayName}`,
                        role: "Owner",
                      },
                    ]}
                  />
                </Grid>
              </Grid>
            </div>
          )}
          {currentTab === "grande-expediente" && (
            <div>
              <Grid spacing={4}>
                <Grid xs={12} lg={3.75}>
                  <GrandeExpediente />
                </Grid>
              </Grid>
            </div>
          )}
          {currentTab === "atas" && (
            <Card>
              <CardHeader title="Atas do Expediente" />

              <Scrollbar>
                <Table sx={{ minWidth: 600 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Título</TableCell>
                      <TableCell>Texto da Ata</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {atas !== undefined &&
                      atas.map((item) => {
                        //@ts-ignore
                        function removeTags(textoHTML) {
                          const div = document.createElement("div");
                          div.innerHTML = textoHTML;
                          return div.textContent || div.innerText || "";
                        }

                        return (
                          <TableRow
                            hover
                            //@ts-ignore
                            key={item.id}
                          >
                            <TableCell>
                              <Typography variant="subtitle1">
                                {/*@ts-ignore*/}
                                {item.tituloAtaExpediente}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              {/*@ts-ignore*/}
                              {removeTags(item.textoAta)}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </Scrollbar>
            </Card>
          )}
          {currentTab === "paltasLegislativas" && (
            <Card>
              <CardHeader title="Pautas Legislativas Cadastradas" />

              <Scrollbar>
                <Table sx={{ minWidth: 600 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Título</TableCell>
                      <TableCell>Texto da Ata</TableCell>
                      <TableCell>Tipo da pauta legislativa</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paltasSessao !== undefined &&
                      paltasSessao.map((item) => {
                        return (
                          <TableRow
                            hover
                            //@ts-ignore
                            key={item.id}
                          >
                            <TableCell>
                              <Typography variant="subtitle1">
                                {/*@ts-ignore*/}
                                {item.numero}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              {/*@ts-ignore*/}
                              {item.expressoes}
                            </TableCell>
                            <TableCell>
                              {/*@ts-ignore*/}
                              {item.paltaLegislativa}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </Scrollbar>
            </Card>
          )}
          {currentTab === "votacaoPaltas" && (
            <Card>
              <CardHeader action={<MoreMenu />} title="Recent Logs" />
              <Scrollbar>
                <Table sx={{ minWidth: 700 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Method</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Path</TableCell>
                      <TableCell>Event</TableCell>
                      <TableCell>Ip</TableCell>
                      <TableCell>Date</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody></TableBody>
                </Table>
              </Scrollbar>
            </Card>
          )}
        </Stack>
      </Container>
    </Box>
  );
}
